export { LocationsScreen } from './LocationsScreen';
